export default {
	title: 'settings',
	components: [
		{ title: 'device_profile', component: 'rgbw_g2_profile' },
		{
			title: 'high_frequency_mode',
			component: 'high_frequency_mode_g2',
			min_ver: '1.4.0',
		},
		{ title: 'input_output', component: 'input_output_g2_rgbw' },
		{ title: 'analog_input_settings', component: 'analog_input_settings_g2' },
		{
			title: 'enable_input',
			component: 'enable_input_per_id_g2',
			min_ver: '1.0.7',
		},
		{ title: 'invert_switch', component: 'invert_switch_per_id_g2' },
		{ title: 'button_fade_rate', component: 'button_fade_rate_g2' },
		{ title: 'button_presets', component: 'button_presets_plus_rgbw' },
		{
			title: 'min_brightness_on_toggle',
			component: 'min_brightness_on_toggle_g2',
		},
		{ title: 'transition_duration', component: 'transition_g2' },
		{ title: 'device_name', component: 'device_name_g2' },
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};
